import { Maybe } from '../../common/model/Monadish';
import { ZonedDateTime } from '../../datetime/ZonedDateTime';
import { PatientActivityClient } from './PatientActivityClient';

type PatientLastActivityWeb = {
  browser: Maybe<string>;
  activeAt: Maybe<ZonedDateTime>;
};
type PatientLastActivityApp = {
  operatingSystem: Maybe<string>;
  version: Maybe<string>;
  activeAt: ZonedDateTime;
};

export type PatientLastClientActivity = {
  lastActivityTimestamp: Maybe<ZonedDateTime>;
  lastActivityClient: Maybe<PatientActivityClient>;
  web: Maybe<PatientLastActivityWeb>;
  app: Maybe<PatientLastActivityApp>;
};

export const PatientLastClientActivity = {
  empty: {
    lastActivityTimestamp: undefined,
    lastActivityClient: undefined,
    app: undefined,
    web: undefined,
  },
};
